import * as React from 'react'
import type {SVGProps} from 'react'
const SvgOhPrintIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={21}
        height={21}
        fill="currentColor"
        viewBox="0 0 21 21"
        {...props}
    >
        <path
            fillRule="evenodd"
            d="M15.9 0c.3 0 .6.3.6.6v4.2h1.8c1 0 1.8.8 1.8 1.8v5.9c0 1-.8 1.8-1.8 1.8h-1.8v1.8c0 .2-.1.3-.2.4l-.8.8-.8.8-.9.9-.3.3-.6.6-.2.2c-.1.1-.3.2-.4.2H4.1c-.3 0-.6-.3-.6-.6v-5.3H1.8c-1 0-1.8-.8-1.8-1.8V6.5c0-1 .8-1.8 1.8-1.8h1.8V.6c0-.3.2-.6.5-.6zm-.6 10.6H4.7v8.2h7v-2.9c0-.3.3-.6.6-.6h2.9v-4.7zm-.9 5.9h-1.5V18zm3.8-10.6H1.8c-.3 0-.6.3-.6.6v5.9c0 .3.3.6.6.6h1.8v-2.3H3c-.3 0-.6-.3-.6-.6s.2-.6.6-.6h14c.3 0 .6.3.6.6s-.3.6-.6.6h-.6V13h1.8c.3 0 .6-.3.6-.6V6.5c0-.3-.2-.6-.6-.6m-2.3 1.2c.3 0 .6.3.6.6s-.3.6-.6.6-.6-.3-.6-.6.2-.6.6-.6m-.6-5.9H4.7v3.6h10.5V1.2z"
            clipRule="evenodd"
        />
    </svg>
)
export default SvgOhPrintIcon
